import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, Select, Events, MenuController, Keyboard} from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { PedidoPage } from '../pedido/pedido';
import { trigger, transition, useAnimation, state, style, animate } from '@angular/animations';
import { tada } from 'ng-animate';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { NativeAudio } from '@ionic-native/native-audio';
import { HomePage } from '../home/home';

/**
 * Generated class for the ProductoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-producto',
  templateUrl: 'producto.html',
  animations:[
    trigger('car',[
      state('open',style({
        backgroundColor:'transparent' 
      })),
      state('close',style({
        backgroundColor:'transparent' 
      })),
      transition('open=>close',useAnimation(tada,{
        params:{
          timing:2
        }
      })),
      transition('close=>open',useAnimation(tada,{
        params:{
          timing:2
        }
      }))
    ]),
    trigger('bus',[
      state('open', style({
        opacity:1,
        display:'initial'
      })),
      state('close', style({
        opacity:0,
        display:'none'
      })),
      transition('open=>close',animate('0.5s')),
      transition('close=>open',animate('0.5s')),
    ])
  ],
  
})
export class ProductoPage {
  producto : any = {}
  url = this.http.images
  carrito : any = {}
  id: any = ''
  cant:any = []
  can : any = 0
  mostrarbuscador: any = false
  add: any = false
  recomendaciones: any = []
  random: any = []
  favoritos: any = []
  fav: any = false
  busqueda: any = ''
  codigo : any = ''
  scanData : any = {}
  opciones : BarcodeScannerOptions
  loading: any = false
  buscados : any = []
  timeout : any = ''
  numerowhat: any
  link:any
  moneda: any = 'USD'
  @ViewChild('sel') selectRef: Select 
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: HttpProvider,
    public alertCtrl: AlertController,
    public events: Events,
    public menuCtrl: MenuController,
    public scanner : BarcodeScanner,
    public sound : NativeAudio,
    public keyboard : Keyboard
    ) {
      if(window.localStorage.moneda){
        this.moneda = window.localStorage.moned
      }
      events.subscribe('carrito:update',()=>{
        this.update()
      })
      events.subscribe('favoritos:update',()=>{
        this.favUpdate()
      })
      this.producto = this.navParams.get('producto')
      this.producto.cant = 1
      for(let i=1; i<this.producto.existencia+1;i++){
        this.cant.push(i)
      }
      if(window.localStorage.getItem('carrito')){
        this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
        this.contar()
      }
      if(window.localStorage.getItem('id')){
        this.id = window.localStorage.getItem('id')
      }
      if(window.localStorage.getItem('favoritos')){
        this.favoritos = JSON.parse(window.localStorage.getItem('favoritos'))
        let favs = this.favoritos.findIndex(el=>{
          return el._id === this.producto._id
        })
        if(favs !== -1){
          this.fav = true
        }else{
          this.fav = false
        }
      }
      // this.cargarRecomendaciones()
      // this.cargarRadom()
      // console.log('se eejcuta esto')
      // this.numerowhat = this.http.nwhatsapp
      // console.log(this.producto.nombre)
      // let texto = this.http.textwhatsapp.replace('{{producto}}', this.producto.nombre)
      // this.link= 'https://api.whatsapp.com/send?phone='+this.numerowhat+'&text='+texto
  }
  ionViewDidEnter(){
    
  }
  
  mostrarocultarbusc(){
    this.mostrarbuscador = !this.mostrarbuscador
  }
  cargarRecomendaciones(){
    this.http.get('productos/categ/'+this.producto.categoria._id+'/'+ this.producto._id).subscribe(
      (res:any)=>{
        res.forEach(el => {
          this.recomendaciones.push(el)
        });
      },
      error=>console.log(error)
    )
  }
  home(){
    this.navCtrl.setRoot(HomePage)
  }
  cargarRadom(){
    this.http.get('productos/random/').subscribe(
      (res:any)=>{
        res.forEach(el => {
          this.random.push(el)
        });
      },
      error=>console.log(error)
    )
  }

  update(){
    if(window.localStorage.getItem('carrito')){
      this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      this.contar()
    }
  }

  favUpdate(){
    if(window.localStorage.getItem('faforitos')){
      this.favoritos = JSON.parse(window.localStorage.getItem('favoritos'))
    }
  }

  contar(){
    // let cant = 0
    // this.carrito.forEach(el=>{
    //   cant += parseFloat(el.cant)
    // })
    this.cant = (this.carrito && this.carrito.articulos && this.carrito.articulos.length > 0) ? this.carrito.articulos.length : 0
  }

  irCarrito(){
    this.navCtrl.push(PedidoPage)
  }

  toggleSelect(){
    this.selectRef.open()
  }

  setItem(){
    // if(this.id.length > 0){
      console.log(this.producto)
      this.carrito = JSON.parse(window.localStorage.getItem('carrito'))
      console.log(this.carrito)
      let val = this.carrito.findIndex(el=>{ 
        return el._id === this.producto._id
      })
      if(val !== -1){
        this.carrito[val].cant = this.carrito[val].cant + this.producto.cant
        // this.carrito[val].cant++
      }else{
        this.carrito.push(this.producto)
      }
      window.localStorage.setItem('carrito', JSON.stringify(this.carrito))
      this.add = !this.add
      this.contar()
      this.events.publish('carrito:update')
    // }else{
    //   this.alertCtrl.create({
    //     title: 'Atención',
    //     subTitle:'Inicia sesión para poder hacer tu cumpra',
    //     buttons:[
    //       {
    //         text:'Cancelar',
    //         cssClass:'btn'
    //       },
    //       {
    //         text:'Aceptar',
    //         cssClass:'btn',
    //         handler:()=>{
    //           this.navCtrl.push(LoginPage)
    //         }
    //       }
    //     ]
    //   }).present()
    // }
  }
  abrirmenu(){
    this.menuCtrl.open();
  }

  agregar(){
    console.log(this.producto.existencia)
    console.log(this.carrito.length)
    if(this.producto.cant < this.producto.existencia ){
      this.producto.cant++
      // this.carrito.map(el=>{
      //   if(el._id === this.producto._id){
      //     el.cant = this.producto.cant
      //   }
      // })
      // window.localStorage.setItem('carrito',JSON.stringify(this.carrito))
      // this.events.publish('carrito:update')
    }
  }

  restar(){
    if(this.producto.cant>1){
      this.producto.cant--
      this.carrito.map(el=>{
        if(el._id === this.producto._id){
          el.cant = this.producto.cant
        }
      })
      window.localStorage.setItem('carrito',JSON.stringify(this.carrito))
      this.events.publish('carrito:update')
    }
  }

  irProducto(item){
    this.navCtrl.push(ProductoPage,{producto:item})
  }

  toogleFav(){
    let fav = this.favoritos.findIndex(el=>{
      return el._id === this.producto._id
    })
    if(fav !== -1){
      this.favoritos.splice(fav,1)
      this.fav = false
    }else{
      this.favoritos.push(this.producto)
      this.fav = true
    }
    window.localStorage.setItem('favoritos',JSON.stringify(this.favoritos))
    this.favUpdate()
    this.events.publish('favoritos:update')
  }

  scan(){
    this.opciones={
      prompt: 'Escaneando código de barras', 
    }
    this.scanner.scan(this.opciones)
      .then(
        data=>{
          this.http.get('productos/sku/'+data.text).subscribe(
            (res:any)=>{
              if(!res){
                this.alertCtrl.create({
                  title:'Atención',
                  subTitle:'No se encontraron resultados para ese producto',
                  buttons:[
                    {
                      text:'Aceptar',
                      cssClass: 'btnAceptar'
                    }
                  ]
                }).present()
              }else{
                this.sound.play('beep')
                this.navCtrl.push(ProductoPage,{producto:res})
              }
            },
            error=>console.log(error)
          )
        },
        error=>console.log(error)
      )
      .catch(error=>console.log(error))
  }

  buscar(){
    if(this.busqueda.length > 1){
      clearTimeout(this.timeout)
      this.timeout = setTimeout(
        ()=>{
          this.loading = true
          this.http.get('productos/search/'+this.busqueda).subscribe(
            (res:any)=>{
              this.keyboard.close()
              this.loading = false
              this.buscados = res
            },
            error=>{
              this.loading = false
              console.log(error)
            }
          )   
        },
        500
      )
    }else{
      this.loading = false
      this.buscados = []
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/producto/producto.ts